import React from "react";
import { Tab } from "@/components/tab";
import { LineageV3 } from "@/components/lineage";
import { TagsList } from "@/pages/settings/tags/components/TagsList";
import { MissingLineage } from "@/pages/biReports/errorPage/MissingLineage";

interface BIReportTabsProps {
  dashboardId: string;
  opportunities?: React.ReactNode;
  has_lineage: boolean;
}

const BIReportTabs: React.FC<BIReportTabsProps> = ({ dashboardId, opportunities, has_lineage }) => {
  const tabs = [
    {
      label: "Opportunities",
      component: opportunities,
    },
    {
      label: "Lineage",
      component: has_lineage ? (
        <LineageV3
          renderTags={TagsList as unknown as Parameters<typeof LineageV3>[0]["renderTags"]}
          assetId={dashboardId}
          assetType="dashboard"
          height="600px"
          exportFinalLineage={true}
        />
      ) : (
        <MissingLineage />
      ),
    },
  ];

  return (
    <Tab
      defaultTab={0}
      onSelectedTabChange={() => {}}
      tabs={tabs}
      fullscreen={true}
      pagedTab={false}
    />
  );
};

export default BIReportTabs;
